import React, { Component } from "react";

export default class Banner extends Component {
    constructor(props) {
        super(props);
        this.state = {
            leftOffset: "-120px"
        };
        this.handleLoadOrResize = this.handleLoadOrResize.bind(this);
    }

    handleLoadOrResize() {
        const windowWidth = document.querySelector(".container").offsetWidth;
        this.setState({ leftOffset: `-${(window.innerWidth - windowWidth) / 2 + 15}px` });
    }

    componentDidMount() {
        this.handleLoadOrResize();
        window.addEventListener("resize", () => {
            this.handleLoadOrResize();
        });
    }

    componentWillUnmount() {
      window.removeEventListener("resize", this.handleLoadOrResize);
    }

    render() {
        return (
            <div className="banner-heading" style={{ width: `${window.innerWidth}px`, left: this.state.leftOffset }}>
                <h1>{this.props.heading}</h1>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/Banner.jsx.erb